import React from 'react';

function MeDocumentationResponseError() {
	return (
		<>
			<div className="fw-bold">Response: Error (400)</div>

			<div className="alert alert-danger mt-3">
				<pre className="mb-0">
					{JSON.stringify({
						status: 'ValidationError',
						message: 'No symbol found',
					}, null, 2)}
				</pre>
			</div>

			<table className="table table-hover">
				<thead>
					<tr>
						<th scope="col" width="17%">Instruction</th>
						<th scope="col" width="23%">Value</th>
						<th scope="col" width="30%">Examples<span className="d-inline d-lg-none">, Comments</span></th>
						<th scope="col" width="30%" className="d-none d-lg-table-cell">Comments</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>status</td>
						<td>ValidationError, ExecutionError, AuthenticationError, ForbiddenError, Error</td>
						<td>&quot;Error&quot; <div className="d-block d-lg-none mt-3"><small>Based on the brokerage response status and more</small></div></td>
						<td className="d-none d-lg-table-cell">Based on the brokerage response status and more</td>
					</tr>
					<tr className="text-secondary">
						<td>message</td>
						<td><i>string</i></td>
						<td>&quot;This order may result in an oversold/overbought position in your account&quot; <div className="d-block d-lg-none mt-3"><small>Extra error details provided by brokerage</small></div></td>
						<td className="d-none d-lg-table-cell">Extra error details provided by brokerage</td>
					</tr>
				</tbody>
			</table>

			<div className="mt-2 text-secondary"><small>
				Error messages generated by the brokers and exchanges are prefixed with their titles.
				For example: &quot;Alpaca:&nbsp;Symbol&nbsp;not&nbsp;found&quot;.
			</small></div>
		</>
	);
}

export default MeDocumentationResponseError;
